// extracted by mini-css-extract-plugin
export default {"firstMainBodySection":"styles_firstMainBodySection__PT7YT"};